<template>
    <div class="main">

      <ProgressBar/>

      <section class="section">

        <h2>Bel de Noodcentrale op 112</h2>

        <p class="text-blue">Professionele hulp is nodig. Bel daarom eerst naar het noodnummer 112. Roep ook de hulp in van een omstander als die er is.</p>

        <div class="lottie-2">
        <Vue3Lottie animationLink="https://lottie.host/71707508-57a8-4a92-917d-98bb0c2fdfa0/aY9sG9sOw4.json"/>
        </div>

      </section>
      
      <section class="click-section">
    
        <Clickheart class="click-heart" @click="nextScene('/aed')"/>

    </section>

    </div>
</template>
<script>

import ProgressBar from "./progress-bar.vue";
import Clickheart from "./click-heart.vue";
  
  export default {
    name: 'Scene1-yellow',
    components: {
        ProgressBar,
        Clickheart
    },
    methods:{
        async yellowTransition() {
      //  console.log('start transition');

        await new Promise(resolve => setTimeout(resolve, 100));
        this.$router.push({ path: '/aed' });
        // console.log("transitioned")
    },
    nextScene(path){
        this.$router.push({ path: path });
    }

    },
    mounted() {
    this.$gtm.trackView('hulpdiensten op 112', '/112');
  }

    }
</script>
<style scoped>

.main{
    background-color: var(--color-yellow);
}
/* header{
    display: grid;
    columns: 4;
    animation: appear 1s ease-in-out forwards;
} */
h2{
    color: var(--color-red);
    margin-top: 10px;
    margin-bottom: 10px;
    opacity: 0;

    animation: appear 1s ease-in-out 0.1s forwards;
}
.text-blue{
    margin-top: 0;
    color: var(--color-dark-blue);
    font-weight: 500;
    font-size: 15px;
    animation: appear 1s ease-in-out 0.3s forwards;
}

.lottie-2{
    max-width: 500px;
    margin-top: 10px;
    width: 35%;
    opacity: 0;
    animation: appear 1s ease-in-out 0.5s forwards;

}

@keyframes appear {
    0%{opacity: 0;}
    100%{opacity: 1;}
  }

@media (min-width: 900px){
h2{
  font-size: 3.125rem;
  
}
.lottie-2{
position: absolute;

max-width: 650px;
right: 5%;
top: 25%;
}
.section{
    align-items: stretch;
    margin-left: 5%;
    margin-top: 10%;
    max-width: 55%
  }
.text-blue{
    max-width: 670px;
    font-size: 30px;
    font-weight: 500;
    /* color: var(--color-purple); */
  }


}



</style>